import useGlobalStore from "@/services/store/useGlobalStore";
import { formatTimestamp } from "@/utils/functions/date";
import { Box, ClickAwayListener, IconButton, List, ListItem, ListItemText, Paper, Typography } from "@mui/material";
import { FC } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import { exportJson } from "@/utils/functions/exportJson";

interface UserTracesProps {
  user: UserWithColor;
  onClose: () => void;
}

const UserTraces: FC<UserTracesProps> = ({ user, onClose }) => {
  const traces = useGlobalStore((state) => state.traces);

  const downloadTrace = (trace: Trace) => {
    exportJson(trace, `trace_${trace.id}.json`);
  };

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Paper
        elevation={5}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "500px",
          padding: "10px",
        }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "1.4em" }}>Traces de {user.alias ?? user.username}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List sx={{ maxHeight: "50vh", overflow: "auto" }}>
          {traces
            .filter((trace) => trace.userId === user.id)
            .map((trace) => (
              <ListItem key={trace.id}>
                <ListItemText
                  primary={`Trace ${trace.id}`}
                  secondary={trace.beginDate ? formatTimestamp(trace.beginDate * 1000) : null}
                />
                <IconButton edge="end" onClick={() => downloadTrace(trace)}>
                  <DownloadIcon />
                </IconButton>
              </ListItem>
            ))}
        </List>
      </Paper>
    </ClickAwayListener>
  );
};

export default UserTraces;
